<div class="theme-display">
    <h4 class="section-title">Office Display</h4>
    <p class="section-subtitle">
        Producer and admin branding that affects office-facing views.
    </p>

    <div class="grid">
        <div class="card">
            <div class="col">
                <h5 class="card-title">Tenant Logo</h5>
                <p class="card-subtitle">
                    Used in the admin panel, the header in producer and host
                    views, and the All Interactives page.
                </p>

                <!--
                    Backed by the tenantLogo key: this drives the host view header logo
                    (themeConfig.tenantLogoUrl). See DisplayGroup note.
                -->
                <app-image-upload
                    class="tenant-logo"
                    label="tenant logo"
                    promptText="Upload Logo"
                    [showBackdrop]="true"
                    [initialUrl]="
                        display().controls.tenantLogoUrl.value || null
                    "
                    (uploaded)="onTenantLogoUpload($event)"
                ></app-image-upload>

                <p class="hint">
                    JPEG, PNG, GIF, WebP, SVG. 5 MB maximum file size. Use a
                    logo that is legible on light backgrounds. Upload a square
                    or wide logo — it keeps its aspect ratio and fits within the
                    header area.
                </p>
            </div>

            <!-- Reserved for future content (e.g. header preview). -->
            <div class="col"></div>
        </div>

        <div class="card">
            <div class="col">
                <h5 class="card-title">Host View Wallpaper</h5>
                <p class="card-subtitle">
                    Wallpaper image will appear as the backdrop in host view.
                </p>

                <app-image-upload
                    class="host-view-wallpaper"
                    label="host view wallpaper"
                    promptText="Upload Wallpaper"
                    [initialUrl]="
                        display().controls.hostViewWallpaperUrl.value || null
                    "
                    (uploaded)="onHostViewWallpaperUploaded($event)"
                ></app-image-upload>

                <p class="hint">JPEG, PNG, GIF, WebP, SVG.</p>
                <p class="hint">5 MB maximum file size.</p>
                <p class="hint">
                    Landscape image recommended. 3:2 works best. Wallpaper will
                    crop to fill the Host View background. Keep important
                    content centered.
                </p>
            </div>

            <!-- Read-only preview of how the wallpaper "crops" into the host view; shown once set. -->
            <div class="col">
                @if (
                    display().controls.hostViewWallpaperUrl.value;
                    as wallpaperUrl
                ) {
                    <div class="previews">
                        <figure class="preview">
                            <div class="frame desktop">
                                <img
                                    class="frame-image"
                                    [src]="wallpaperUrl"
                                    alt="Desktop host view preview"
                                />
                            </div>
                        </figure>

                        <figure class="preview">
                            <div class="frame tablet">
                                <img
                                    class="frame-image"
                                    [src]="wallpaperUrl"
                                    alt="Tablet host view preview"
                                />
                            </div>
                        </figure>
                    </div>
                    <p class="hint">Tablet crop previews</p>
                    <p class="hint">
                        Same image, center-cropped to fill each screen. Keep
                        important content centered.
                    </p>
                }
            </div>
        </div>
    </div>
</div>
